<!-- eslint-disable max-len -->
<template>
  <div class="meetings">
    <v-navigation-drawer class="hero-img" permanent dark style="height: 100vh;">
      <v-list-item dense style="padding: 0px; padding-right: 15px; padding-left: 15px">
        <v-list-item-content>
          <v-row>
            <v-col style="padding-bottom: 0; padding-top: 0;">
              <v-img contain width="150" src="../../assets/tbmlogo.png"
                ></v-img>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item dense style="padding: 0px; padding-right: 15px; padding-left: 15px">
        <v-list-item-content>
          <v-tabs
            :hide-slider="true"
            class="pa-n1"
            flat
            text
            fixed-tabs
            dense
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab @click="viewSetting('detailedView')" class="caption">
              Detailed View
            </v-tab>
            <v-tab v-if="hasFeature('overview')" @click="viewSetting('overView')" class="caption">
              Overview
            </v-tab>
          </v-tabs>
        </v-list-item-content>
      </v-list-item>
      <v-btn x-small class="ml-4 mb-2" @click="openLedgerDialog" v-if="hasFeature('terminalLedger') && checkUserTerminalLedger" >Terminal Ledger</v-btn>
      <v-divider></v-divider>
      <v-list-item dense style="padding: 0px; padding-right: 15px; padding-left: 15px">
        <v-list-item-content>
          <v-row>
            <v-col style="padding-bottom: 0; padding-top: 0;">
              <search-filter :resetFilters="resetFilters" :viewType="viewType"/>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item dense style="padding: 0px; padding-right: 15px; padding-left: 15px">
        <v-list-item-content>
          <v-row>
            <v-col style="padding-bottom: 0; padding-top: 0;">
              <v-btn small color="success" width="100%"
                @click="clearSelections(), selectedAll()">
                All Meetings
                <v-icon style="padding-left: 15px" small>mdi-reload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <div class="meetings-scroll" v-if="!loading && meetings">
        <Meeting
          :summary="summary" :meetings="meetings" :racesLoading="racesLoading" :viewType="viewType" :updateDataTableHeight="updateDataTableHeight"/>
      </div>
      <div v-else>
        <v-list v-for="idx in 20" :key="idx" class="meetings-list">
          <v-skeleton-loader
            type="list-item-avatar"
          ></v-skeleton-loader>
        </v-list>
      </div>
    </v-navigation-drawer>
    <TerminalLedger :LedgerDialog="LedgerDialog" :LedgerDialogClose="LedgerDialogClose"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Meeting from '../Meeting'
import TerminalLedger from '../TerminalLedger'
import SearchFilter from '../SearchFilter'

export default {
  name: 'Meetings',
  components: {
    Meeting,
    SearchFilter,
    TerminalLedger
  },
  data () {
    return {
      resetFilters: false,
      LedgerDialog: false
    }
  },
  props: {
    meetings: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    racesLoading: {
      type: Boolean,
      default: false
    },
    summary: {
      type: Boolean,
      default: false
    },
    viewSetting: {
      type: Function
    },
    viewType: {
      type: String
    },
    updateDataTableHeight: {
      type: Function
    }
  },
  computed: {
    ...mapGetters(['hasFeature', 'getUser']),
    checkUserTerminalLedger () {
      const user = this.getUser
      return user.attributes['custom:ledger_access'] === '1'
    }
  },
  methods: {
    ...mapActions(['setSelectedMeeting', 'updateNoRacesAvail', 'fetchBookieRace', 'fetchBetsByCustomer', 'updateAllRaces', 'fetchMeetings', 'fetchBets', 'fetchAllRaces', 'fetchRaces', 'clearSelections', 'fetchBetsByType', 'fetchBookieBets', 'fetchBookieBetsDated', 'fetchEnrolledTerminals']),
    LedgerDialogClose () {
      this.LedgerDialog = false
    },
    selectedAll () {
      // this.fetchBets({ pagination: { page: 1, limit: 5 }, filtered: true });
      this.$store.commit('clearRunners')
      this.updateAllRaces(true)
      this.updateNoRacesAvail(false)
      this.clearSelections()
      // this.fetchAllRaces()
      this.fetchMeetings()
      // this.fetchBetsByType()
      this.fetchBookieBets()
      // this.fetchBookieBetsDated()
      if (this.viewType === 'overView') {
        this.fetchBookieBetsDated()
        this.fetchBetsByCustomer()
        this.fetchBetsByType()
        this.fetchBookieRace()
      }
      this.resetFilters = true
      setTimeout(() => {
        this.resetFilters = false
      }, 1000)
    },
    openLedgerDialog () {
      this.fetchEnrolledTerminals()
      this.LedgerDialog = true
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.activeBtn {
  background-color: rgb(233, 10, 124) !important;
}
.header button {
  margin-left: 40px;
}
.meetings-list {
  padding: 0px;
}
.meetings-scroll {
  height: 50vh;
  overflow-y: scroll;
}
.hero-img {
  background-size: cover;
  width: 100%;
  height: 100%;
  background-image: url('../../assets/tbmsidebar.png');
}
</style>
